import QdtComponents from 'qdt-components'

const isFinal = false
const isTesting = false

export default ({ app }, inject) => {
  const host = app.$host

  const appId = isFinal
  ? 'use-the-final-qlik-id-for-the-app'
  : isTesting
  ? 'b54d292f-7648-4207-9dfe-abdf78a12785'
  : 'c3b5a2e3-5cbe-4c41-b931-52d6c7b72cdc'

  const config = {
    host,
    prefix: '',
    port: 443, // window.location.port,
    secure: true,
    appId,
  }
  const connections = {
    vizApi: true,
    engineApi: true,
  }
  const qdtComponents = new QdtComponents(config, connections)

  inject('qdt', qdtComponents)
}
